<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiLogout } from "@mdi/js"

export default {
  name: "LogoutIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiLogout,
    }
  }
}
</script>
